import React from "react";

const TermsConditions = () => {
  return (
    <div className="max-w-5xl mx-auto p-8">
      <h1 className="text-3xl font-bold mb-6">
        EarnProjectAcademy – Terms of Service
      </h1>

      <p className="mb-4">
        Welcome to EarnProjectAcademy. These Terms of Service ("Terms") govern your access to and use of our website and services operated by EarnProjectAcademy. By accessing or using our website (https://earnprojectacademy.com), you agree to be legally bound by these Terms along with our Privacy Policy, Refund Policy, and other applicable policies. If you do not agree, please do not access or use our services.
      </p>

      <h2 className="text-xl font-semibold mt-6">1. Use License</h2>
      <p>
        EarnProjectAcademy grants you a limited, non-exclusive, non-transferable license to temporarily access course materials for personal, non-commercial use only. You may not:

     Modify or copy materials

     Use materials for commercial or public display

    Reverse engineer or decompile any software

         Remove copyright or proprietary notations

     Mirror the materials on other servers

       This license terminates automatically if any of these terms are violated.
      </p>

      <h2 className="text-xl font-semibold mt-6">2. Communication Policy</h2>
      <p>
        By registering or submitting your details, you consent to receive communications via email, phone, SMS, or WhatsApp from EarnProjectAcademy or its service providers. You may opt out at any time by:

      Emailing us at info@earnprojectacademy.com

      Clicking the unsubscribe link in our emails
      </p>

      <h2 className="text-xl font-semibold mt-6">3. Accuracy of Materials</h2>
      <p>
        We strive for accuracy, but EarnProjectAcademy does not guarantee that materials on our website are current, complete, or error-free. We may change content at any time without notice but are not obligated to update it.
      </p>

      <h2 className="text-xl font-semibold mt-6">4. Links to Third-Party Sites</h2>
      <p>
      EarnProjectAcademy is not responsible for the content or accuracy of third-party websites linked to our platform. Users access such sites at their own risk.
      </p>

      <h2 className="text-xl font-semibold mt-6">5. Disclaimer</h2>
      <p>
        All materials are provided “as is”. EarnProjectAcademy disclaims all warranties, expressed or implied, including merchantability or fitness for a particular purpose. We make no guarantees regarding results, reliability, or accuracy.
      </p>

       <h2 className="text-xl font-semibold mt-6">6. Limitations of Liability</h2>
      <p>
       EarnProjectAcademy shall not be liable for any damages arising from your use or inability to use our services, including but not limited to data loss, business interruption, or indirect losses.
      </p>

       <h2 className="text-xl font-semibold mt-6">7. Prohibited Use</h2>
      <p>
       You may not use the website:

For unlawful activities

To infringe intellectual property rights

To transmit malware or harmful code

To violate any applicable laws or regulations

Violation of these terms may result in immediate termination of access.
      </p>

      <h2 className="text-xl font-semibold mt-6">8. Intellectual Property </h2>
      <p>
       All content on the EarnProjectAcademy website—including logos, text, videos, and course materials—is owned or licensed by EarnProjectAcademy and protected by copyright and trademark laws.
      </p>
      
       <h2 className="text-xl font-semibold mt-6">9. User Submissions </h2>
      <p>
       Any ideas, feedback, or suggestions submitted by users may be used by EarnProjectAcademy without compensation or restriction.
      </p>
       
      <h2 className="text-xl font-semibold mt-6">10. Governing Law </h2>
      <p>
       These Terms are governed by the laws of India, and all disputes shall fall under the jurisdiction of courts in India.
      </p>

      <h2 className="text-xl font-semibold mt-6">Contact Information</h2>
      <p>📧 Email: info@earnprojectacademy.com
         🌐 Website: https://earnprojectacademy.com</p>
    </div>
  );
};

export default TermsConditions;